module.exports = __webpack_public_path__ + "static/media/icon-success.eba5366f.svg";